import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { card as styles } from "./styles";
import { withRouter } from "react-router-dom";
import { version } from "../../config";

import {
	// Typography,
	Card as MuiCard,
	CardHeader,
	CardContent,
	Fab,
	Avatar,
	withStyles
} from "@material-ui/core";

import { ReactComponent as ShareIcon } from "../../assets/images/icons/share.svg";
import { ReactComponent as TargetIcon } from "../../assets/images/icons/target.svg";

import Content from "./Content";

import { Share } from "../index";
import { setFrame } from "../../store/canvas";

class Card extends React.Component {
	constructor(props) {
		super(props);
		this.anchorEl = React.createRef();
	}

	state = {
		anchorEl: null,
		element: "button",
		open: false
	};

	setButtonRef = element => {
		this.anchorEl = element;
		this.setState(prevState => ({
			...prevState,
			element
		}));
	};

	handleShareOpen = event => {
		this.setState({ anchorEl: event.currentTarget });
		event.cancelBubble = true;
		if (event.stopPropagation) {
			event.stopPropagation();
		}

		return false;
	};

	handleShareClose = () => {
		this.setState(prevState => ({
			...prevState,
			anchorEl: null
		}));
	};

	handleTarget = event => {
		if (event.stopPropagation) {
			event.stopPropagation();
		}
		const { coordinates, frame, setFrame } = this.props;

		let desiredFrame = frame;

		const filteredCoords = coordinates.filter((item, index) => {
			if (index === Math.floor(coordinates.length / 2)) {
				desiredFrame = item._column;
			}
			return item._column === frame;
		});

		if (filteredCoords.length === 0) {
			setFrame(desiredFrame);
		}
		return false;
	};

	goToPoi = event => {
		// const currentLocation = window.location.hash.replace(/#/u, "");

		event.persist();
		const { item, history } = this.props;
		history.push(`/lot/${item.lot}`);

		event.cancelBubble = true;
		if (event.stopPropagation) {
			event.stopPropagation();
		}
		return false;
	};

	handleMouseEnter = () => {
		const { item, setHoveredLot } = this.props;
		setHoveredLot(item.lot);
		return false;
	};

	handleMouseLeave = () => {
		const { setHoveredLot } = this.props;
		setHoveredLot(false);
		return false;
	};

	render() {
		const { classes, item } = this.props;
		const { anchorEl } = this.state;
		const open = Boolean(anchorEl);
		let type = item.type.replace(/\D/gimu, "");
		if (item.type === "ST" || item.type === "st") {
			type = 1;
		}
		const imgBackground = `backgroundColor${type}`;

		const url = `${window.location.href.split("#")[0]}#lot/${item.lot}`;

		let pieces = item.type.replace(/(?!\/)\D+/gimu, "");
		if (item.type === "ST" || item.type === "st") {
			pieces = 1;
		}

		let cardTitle = `Appartement ${pieces} ${pieces === "1" ? "pièce" : "pièces"}`;

		if(version.office) {
			cardTitle = item.name || item.title;
		}

		return (
			<MuiCard
				className={classes.card}
				onClick={this.goToPoi}
				onMouseEnter={this.handleMouseEnter}
				onMouseLeave={this.handleMouseLeave}
			>
				<CardHeader
					action={
						<div>
							<Fab
								style={{
									marginRight: 8
								}}
								classes={{
									root: classes.cardAction
								}}
								onClick={this.handleTarget}
							>
								<TargetIcon className={classes.btn} />
							</Fab>
							<Fab
								aria-haspopup="true"
								aria-owns={this.state.open ? "simple-popper" : null}
								buttonRef={this.setButtonRef}
								classes={{
									root: classes.cardAction
								}}
								onClick={this.handleShareOpen}
							>
								<ShareIcon className={classes.btn} />
							</Fab>
							<Share
								element={this.anchorEl}
								onClose={this.handleShareClose}
								open={open}
								url={url}
							/>
						</div>
					}
					avatar={
						<Avatar
							aria-label="Recipe"
							className={classNames(classes.avatar, imgBackground)}
							style={{
								fontSize: item.lot.length <= 3 ? "0.8rem" : "0.6rem"
							}}
						>
							{item.lot}
						</Avatar>
					}
					classes={{
						root: classes.cardHeader,
						title: classes.title,
						avatar: classes.avatarRoot
					}}
					// subheader={}
					title={cardTitle}
					titleTypographyProps={{
						variant: "h3"
					}}
				/>
				<CardContent
					classes={{
						root: classes.cardContent
					}}
				>
					<Content item={item} />
				</CardContent>
			</MuiCard>
		);
	}
}

Card.propTypes = {
	classes: PropTypes.object.isRequired,
	item: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(Card));
